:host {
  display: block;
  --navigation-columns-number: 1;

  @include media-min(lg) {
    --navigation-columns-number: 1;
  }

  @include media-min(xl) {
    --navigation-columns-number: 3;
  }

  --min-entries: 6;
}

.main-nav-item {
  // position: relative;

  &.is-active {
    .main-nav-item-content {
      display: block;

      @include media-max(xl) {
        translate: 0 0;
        overflow-y: scroll;
      }
    }
  }
}

.main-nav-item-trigger {
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  padding: 4px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;

  @include media-min(xl) {
    width: auto;
    background-color: transparent;
    padding: 16px 24px;
    display: flex;
    position: relative;

    &.is-active,
    &:hover {
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 4px;
        background-color: $color-turquoise-01;
      }
    }

    &:focus-visible {
      outline: 2px solid $color-turquoise-03;
      outline-offset: -2px;
    }

    &:hover:focus-visible,
    &.is-active:focus-visible {
      &:before {
        bottom: 3px;
        left: 3px;
        right: 3px;
      }
    }

    dc-ui-icon {
      display: none;
    }
  }
}

.main-nav-item-title {
  text-align: left;
  text-transform: uppercase;
  color: $color-dark-blue-02;
  @include font-style('strong-text');

  @include media-min(xl) {
    line-height: 16px;
    white-space: nowrap;
  }
}

.main-nav-item-content {
  display: none;
  position: fixed;
  inset: 0;
  background-color: $color-white;
  border-top: 1px solid $color-grey-01;
  z-index: 1;
  padding: 32px 24px 48px;

  @include media-max(xl) {
    display: block;
    transition: translate 0.3s ease;
    translate: 100% 0;
  }

  @include media-min(xl) {
    padding: 0;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    bottom: unset;
    max-width: var(--header-max-width);
    margin-inline: auto;
    box-shadow: 0px 16px 24px -4px rgba($color-dark-blue-02, 0.12);
  }
}

.navigation-body {
  display: grid;
  row-gap: 24px;
  align-content: start;

  @include media-min(xl) {
    box-sizing: border-box;
    max-width: 1170px;
    margin-inline: auto;
    overflow: hidden;
    position: relative;
    padding-block: 24px;
    row-gap: 8px;
    min-height: max(
      calc(
        32px * min(var(--max-entries), var(--default-max-entries)) +
          (min(var(--max-entries), var(--default-max-entries)) - 1) * 10px + 32px + 8px + 48px
      ),
      calc(var(--min-entries) * 32px + (var(--min-entries) - 1) * 10px + 32px + 8px + 48px)
    );

    dc-ui-header-nav-breadcrumb {
      min-height: 32px;
      margin-right: 32px;
    }
  }
}

#close-icon {
  display: none;

  @include media-min(xl) {
    display: block;
    position: absolute;
    top: 24px;
    right: 0;
  }
}

.navigation-rows-wrapper {
  min-width: 0; /* fix for grid layout */
  display: flex;
  height: 100%;
  --translateX: min(
    0%,
    calc(
      (-100% / var(--navigation-columns-number)) *
        (var(--navigation-columns-current) - var(--navigation-columns-number))
    )
  );
  transition: transform 0.5s;
  transform: translate(var(--translateX));

  @include media-max('xl') {
    gap: 30px;
    --translateX: min(
      0%,
      calc(
        ((-100% - 30px) / var(--navigation-columns-number)) *
          (var(--navigation-columns-current) - var(--navigation-columns-number))
      )
    );
  }

  > * {
    width: calc(100% / var(--navigation-columns-number));
    flex: 0 0 auto;
  }
}

::slotted(*) {
  width: calc(100% / var(--navigation-columns-number));
  flex: 0 0 auto;
}

::slotted(.menu-container) {
  padding: 0;
  margin: 0;
  list-style: none;
  display: none;
}

::slotted(.menu-container.active) {
  display: grid;
  grid-auto-flow: row;
  row-gap: 10px;
  align-content: start;
  overflow-y: auto;

  @include media-min(xl) {
    max-height: calc(32px * var(--default-max-entries) + (var(--default-max-entries) - 1) * 10px);
  }
}
